// extracted by mini-css-extract-plugin
export var logo = "_la-2";
export var logoWrapper = "_la-1";
export var strip = "_la-0";